export default __webpack_public_path__ + "static/mobile_menu_background-673e6d8fc1c6b12acd1031918c694ac1.png";